module.exports = __webpack_public_path__ + "img/153.61defb88.jpg";